import {exibirMensagem, HttpVerbo, xfetch} from "../util";
import {SetorDto} from "../tipos/dto/setor-dto";
import {Setor} from "../tipos/setor";

const url = '/setor'
export default class SetorServico {


  static buscarSetores = async (): Promise<SetorDto[]> => {
    let res = await xfetch(url, {}, HttpVerbo.GET)
        .catch(e => alert(e.message))
    return res.json();
  }

  static salvarSetor(dados: Setor) {
    return xfetch(url, dados, HttpVerbo.POST).catch(e => exibirMensagem(e.message))
  }
  static alterarSetor(dados: Setor) {
    return xfetch(url, dados, HttpVerbo.PUT).catch(e => exibirMensagem(e.message))
  }
}